<template>
  <v-card>
    <v-container>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="4">
          <v-menu
            ref="menuFrom"
            v-model="fromMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                v-model="from"
                label="Od"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="from"
              no-title
              scrollable
              locale="cz-cs"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col cols="4">
          <v-menu
            ref="menuTo"
            v-model="toMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                dense
                v-model="to"
                outlined
                label="Do"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="to"
              no-title
              scrollable
              locale="cz-cs"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
        <v-col
          cols="4">
          <v-btn
            dark
            color="success"
            @click="exportOrders"
          >Export</v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import ExcelJS from 'exceljs'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
export default {
  name: 'ExportOrdersForm',
  props: ['type', 'orders'],
  data () {
    return {
      from: '',
      to: '',
      fromMenu: false,
      toMenu: false
    }
  },
  methods: {
    exportOrders () {
      if (this.type === 'xlsx') {
        this.exportExcel()
      } else {
        this.exportPdf()
      }
    },
    exportExcel () {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Objednávky')
      sheet.mergeCells('A1:C1')
      sheet.getCell('A1').value = 'Objednávky'

      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      sheet.mergeCells('A2:C2')
      sheet.getCell('A2').value = `${nowCzDate} ${nowCzTime}`

      sheet.mergeCells('A3:C3')
      sheet.getCell('A3').value = `Období: ${new Date(this.from).toLocaleDateString('cs-CZ')} - ${new Date(this.to).toLocaleDateString('cs-CZ')}`

      sheet.getRow(5).values = [
        'Číslo objednávky',
        'Jídelníček',
        'Id uživatele',
        'Jméno',
        'Příjmení',
        'Ulice',
        'č. p.',
        'Město',
        'PSČ',
        'Celková cena',
        'Způsob platby',
        'Stav'
      ]

      sheet.columns = [
        { key: 'id', width: 20 },
        { key: 'dietName', width: 20 },
        { key: 'userId', width: 20 },
        { key: 'userFirstName', width: 20 },
        { key: 'userLastName', width: 20 },
        { key: 'deliveryStreet', width: 20 },
        { key: 'deliveryStreetNumber', width: 10 },
        { key: 'deliveryCity', width: 20 },
        { key: 'deliveryZip', width: 10 },
        { key: 'price', width: 10 },
        { key: 'paymentType', width: 20 },
        { key: 'state', width: 20 }
      ]

      let rowOffset = 6
      this.filteredOrders.forEach((order, index) => {
        sheet.getRow(rowOffset).values = {
          ...order,
          dietName: order.diet.name,
          userId: order.user.id,
          userFirstName: order.user.firstName,
          userLastName: order.user.lastName
        }
        if (order.state === 'Stornovaná') {
          sheet.getRow(rowOffset).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f56042' }
          }
        } else {
          sheet.getRow(rowOffset).fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFF00' }
          }
        }
        rowOffset += 1
        Object.keys(order.items).forEach(date => {
          const day = order.items[date]
          const times = ['Snídaně', 'Dopolední svačina', 'Oběd', 'Odpolední svačina', 'Večeře', 'Druhá večeře']
          for (let i = 0; i < 6; i++) {
            // denni doba ma itemy
            if (day[i].length) {
              sheet.getRow(rowOffset).values = {
                id: '',
                userId: 'Datum',
                userFirstName: new Date(date).toLocaleDateString('cs-CZ'),
                userLastName: ''
              }
              sheet.getRow(rowOffset).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'e0f542' }
              }
              rowOffset += 1

              sheet.getRow(rowOffset).values = {
                id: '',
                userId: '',
                userFirstName: '',
                userLastName: 'Název položky',
                deliveryStreet: 'Množství',
                deliveryStreetNumber: 'Cena',
                deliveryCity: 'Alergeny',
                deliveryZip: 'Kalorie'
              }
              sheet.getRow(rowOffset).fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'e0f542' }
              }
              rowOffset += 1

              for (let j = 0; j < day[i].length; j++) {
                const meal = day[i][j]
                sheet.getRow(rowOffset).values = {
                  id: '',
                  userId: '',
                  userFirstName: j === 0 ? times[i] : '',
                  userLastName: meal.name,
                  deliveryStreet: meal.quantity,
                  deliveryStreetNumber: meal.price,
                  deliveryCity: meal.alergens.map(a => a.name).join(', '),
                  deliveryZip: meal.calories
                }
                sheet.getRow(rowOffset).fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'f5da42' }
                }
                sheet.getRow(rowOffset).border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
                }
                rowOffset += 1
              }
            }
          }
        })
        // console.log(sheet.getRow(rowOffset).getCell(2).address)
        rowOffset += 1
      })
      sheet.eachRow(row => {
        row.eachCell(cell => {
          cell.alignment = { vertical: 'middle', horizontal: 'right' }
        })
      })
      workbook.xlsx.writeBuffer().then(data => {
        const blob = new Blob([data],
          { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const anchor = document.createElement('a')
        anchor.href = url
        anchor.download = 'export_objednavky.xlsx'
        anchor.click()
        window.URL.revokeObjectURL(url)
        this.$emit('exported')
      })
    },
    exportPdf () {
      const now = new Date()
      const nowCzDate = now.toLocaleDateString('cs-CZ', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
      const nowCzTime = now.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      const tableRowsOrders = []
      this.filteredOrders.forEach(order => {
        tableRowsOrders.push([
          order.id,
          order.diet.name,
          order.user.id,
          order.user.firstName,
          order.user.lastName,
          order.deliveryStreet,
          order.deliveryStreetNumber,
          order.deliveryCity,
          order.deliveryZip,
          order.price,
          order.paymentType,
          order.state
        ])

        Object.keys(order.items).forEach(date => {
          const day = order.items[date]
          tableRowsOrders.push([
            '',
            'Datum',
            new Date(date).toLocaleDateString('cs-CZ'),
            '', '', '', '', '', '', '', '', '' // zbyvajici bunky
          ])

          const times = ['Snídaně', 'Dopolední svačina', 'Oběd', 'Odpolední svačina', 'Večeře', 'Druhá večeře']
          for (let i = 0; i < 6; i++) {
            // denni doba ma itemy
            if (day[i].length) {
              tableRowsOrders.push([
                '',
                '',
                '',
                'Název položky',
                'Množství',
                'Cena',
                'Alergeny',
                'Kalorie',
                '', '', '', ''// zbyvajici bunky
              ])

              for (let j = 0; j < day[i].length; j++) {
                const meal = day[i][j]
                tableRowsOrders.push([
                  '',
                  '',
                  j === 0 ? times[i] : '',
                  meal.name,
                  meal.quantity,
                  meal.price,
                  meal.alergens.map(a => a.name).join(', '),
                  meal.calories,
                  '', '', '', '' // zbyvajici bunky
                ])
              }
            }
          }
        })
      })
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      const docDefinition = {
        pageOrientation: 'landscape',
        content: [
          {
            text: 'Objednávky'
          },
          {
            text: `${nowCzDate} ${nowCzTime}`
          },
          {
            text: `Období: ${new Date(this.from).toLocaleDateString('cs-CZ')} - ${new Date(this.to).toLocaleDateString('cs-CZ')}`
          },
          {
            table: {
              dontBreakRows: true,
              body: [
                [
                  'Číslo objednávky',
                  'Jídelníček',
                  'Id uživatele',
                  'Jméno',
                  'Příjmení',
                  'Ulice',
                  'č. p.',
                  'Město',
                  'PSČ',
                  'Celková cena',
                  'Způsob platby',
                  'Stav'
                ],
                ...tableRowsOrders
              ]
            }
          }
        ]
      }
      pdfMake.createPdf(docDefinition).download('export_objednavky')
      this.$emit('exported')
    }
  },
  created () {
    const currentDate = new Date()
    const lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0)
    this.from = `${currentDate.getFullYear()}-${currentDate.getMonth() < 9 ? '0' + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1}-01`
    this.to = `${currentDate.getFullYear()}-${currentDate.getMonth() < 9 ? '0' + (currentDate.getMonth() + 1) : currentDate.getMonth() + 1}-${lastDay.getDate()}`
  },
  computed: {
    filteredOrders () {
      return this.orders.filter(order => {
        const toTmp = new Date(this.to)
        const to = new Date(new Date(toTmp).setDate(toTmp.getDate() + 1))
        const from = new Date(this.from)
        const paymentDate = new Date(order.createdAt)
        return paymentDate.getTime() < to.getTime() && paymentDate >= from.getTime()
      })
    }
  }
}
</script>

<style scoped>

</style>
